/**
 * yearEndGalleryUtils.js
 *
 * Firestore queries for Year-End Gallery page
 * Uses compat API matching yearEndCache.js pattern
 */

import { dbService } from '../firebaseInstance';

const PAGE_SIZE = 100;

/**
 * Fetch year-end reviews for gallery
 *
 * @param {Object} options
 * @param {*} options.lastDoc - Last document snapshot for pagination
 * @param {number} options.year - Year filter (default: 2025)
 * @returns {Promise<{items: Array, lastDoc: *|null, hasMore: boolean}>}
 */
export async function fetchYearEnds({
  lastDoc = null,
  year = 2025
} = {}) {
  try {
    let query = dbService
      .collection('yearEnd')
      .where('year', '==', year)
      .orderBy('computedAt', 'desc')
      .limit(PAGE_SIZE + 1);

    if (lastDoc) {
      query = query.startAfter(lastDoc);
    }

    const snapshot = await query.get();
    const docs = snapshot.docs;
    const hasMore = docs.length > PAGE_SIZE;

    const items = docs.slice(0, PAGE_SIZE).map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    const newLastDoc = docs.length > 0
      ? docs[Math.min(docs.length - 1, PAGE_SIZE - 1)]
      : null;

    return {
      items,
      lastDoc: newLastDoc,
      hasMore
    };
  } catch (error) {
    console.error('[yearEndGalleryUtils] fetchYearEnds error:', error);
    throw error;
  }
}
